import Animated from "react-native-reanimated";
export function createAnimatedComponent(component, options) {
    return Animated.createAnimatedComponent(component, options);
}
